<template src="./index.html">
</template>
<script>
	import {getdata} from './data.js'
    import config from '../../../../../../../configHttp.js'
    export default {
		props:{
			toseeUpdate: {
				type: Boolean,
				default: false
			},
			  tableData:{
				  type:Array,
				  default:[],
			  },
			  headobj:{
				  type:Object,
				  default:{},
			  },
			  choosecellCode:{
			  	type:String,
			  	default:""
			  },
			  type: {
			  	type: String,
			  	default: ""
			  },
		},
		name: '',
		components: {},
		data: function() {
			return {
				headData: getdata().headData,
                config:config.company,
				jbrlx:getdata().jbrlx,
			};
		},

		created() {
		},
		methods: {
			select_el(){
				this.jbrlx.map(item=>{
					if(item.value==this.headobj.shenfzlx){
						this.headobj.shenfzlxbh = item.lebal
					}
				})
				this.$emit("elinput",this.headobj)
			},
			radio(){
				this.$emit("elinput",this.headobj)
			},
			elinput(){
				this.$emit("elinput",this.headobj)
			},
			zcsclick(e){
				this.$emit("zcsclick",e)
			},
			forhover(table,colum,index){
				this.$emit("forhover",table,colum,index)
			},
			inputblur(e){
				this.$emit("inputblur",e)
			},
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0) {
					if (rowIndex === 0) {
						return {
							rowspan: 10,
							colspan: 1
						};
					} else if (rowIndex === 10) {
						return {
							rowspan: 14,
							colspan: 1
						};
					} else if (rowIndex === 24) {
						return {
							rowspan: 14,
							colspan: 1
						};
					} else if (rowIndex === 38) {
						return {
							rowspan: 3,
							colspan: 1
						};
					} else if (rowIndex === 41) {
						return {
							rowspan: 1,
							colspan: 2
						};
					} else {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
				if (columnIndex === 1) {
					if (rowIndex === 41) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
				if (columnIndex === 2) {
					if (rowIndex === 41) {
						return {
							rowspan: 1,
							colspan: 2
						};
					}
				}
				if (columnIndex === 3) {
					if (rowIndex === 41) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
				if (columnIndex === 5) {
					if (rowIndex === 41) {
						return {
							rowspan: 1,
							colspan: 2
						};
					}
				}
				if (columnIndex === 5) {
					if (rowIndex === 41) {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
			},
			headercellstyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (rowIndex === 0) {
					if (columnIndex === 0) {
						this.$nextTick(() => {
							if (document.getElementsByClassName(column.id).length !== 0) {
								document
									.getElementsByClassName(column.id)[0]
									.setAttribute('colSpan', 2);
							}
						});

					}
					if (columnIndex === 1) {
						return {
							display: "none"
						};
					}
				}

			},
		}
	};
</script>


<style scoped lang="less">
	@import url('./index.less');
	@import url('../../SalesTaxReport/index.less');
</style>
